/* eslint react/no-danger: 'off' */
/* global globals, translations */
import React from 'react';
import get from 'lodash/get';

const VipIntro = () => (
  <div>
    <div
      className="mbs"
      dangerouslySetInnerHTML={{
        __html: get(translations, 'txt: VIP abonements ļauj portālu izmantot VIP režīmā, kam galvenā priekšrocība ir anonimitāte.', ''),
      }}
    />
    <div
      className="mbm"
      dangerouslySetInnerHTML={{
        __html: get(translations, 'txt: Atrodoties VIP režīmā, anonīmi var apskatīt citu lietotāju profilus un veikt arī dažas citas darbības.', ''),
      }}
    />
    {get(globals, 'hasVerificationRestrictions', false) && (
      <div
        className="mbm"
        dangerouslySetInnerHTML={{
          __html: get(translations, 'txt: Atrodoties VIP režīmā, netiek ņemti vērā verifikācijas ierobežojumi.', ''),
        }}
      />
    )}
  </div>
);

export default VipIntro;
